import type { SVGProps } from 'react'

// Official CoW Swap icon (circle variant, light-blue background) from the CoW
// brand kit.
const CowSwap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect fill="#65d9ff" height="400" rx="200" width="400" />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      fill="#012f7a"
      d="m166.774 304c-13.368 0-25.196-8.655-29.237-21.395l-20.779-65.494h-12.774c-13.3677 0-25.1958-8.655-29.2373-21.395l-12.3463-38.916h46.3096l-24.4256-36.8h231.4316l-24.425 36.8h46.309l-12.346 38.916c-4.041 12.74-15.87 21.395-29.237 21.395h-12.775l-20.778 65.494c-4.041 12.74-15.869 21.395-29.237 21.395zm-15.698-104.778c0 9.88 7.378 17.889 16.478 17.889 9.101 0 16.479-8.009 16.479-17.889s-7.378-17.889-16.479-17.889c-9.1 0-16.478 8.009-16.478 17.889zm97.849 0c0 9.88-7.378 17.889-16.478 17.889-9.101 0-16.479-8.009-16.479-17.889s7.378-17.889 16.479-17.889c9.1 0 16.478 8.009 16.478 17.889z"
    />
  </svg>
)

export default CowSwap
